import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';

import PopFinishesCarousel from './PopFinishesCarousel';
import PopFinishesContent from './PopFinishesContent';
import type { PopFinishesCarouselSlideData } from './types';

export interface PopFinishesProps {
  readonly carouselSlides: PopFinishesCarouselSlideData[];
}

const PopFinishes = ({ carouselSlides }: PopFinishesProps) => {
  return (
    <section data-cy="pop-finishes-section">
      <LayoutGrid rowGap={48}>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <PopFinishesContent />
        </GridItem>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <PopFinishesCarousel slides={carouselSlides} />
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default PopFinishes;
